import { Action, AnyAction, applyMiddleware, compose, createStore, Store as ReduxStore } from "redux";
import { ActionLog, createActionLog } from "redux-action-log";
import thunk from "redux-thunk";
// import ProductAnalyticsMiddleware from "src/store/productAnalyticsMiddleware";
import { ApplicationStore as IApplicationStore } from "src/store/types/state";
import * as actions from "./actions";
import dataService from "./dataService";
import garageManagement from "./garageManagement";
import dynamicGarageReporter from "./dynamicGarageReporters";
import reducer from "./reducers";

export interface ApplicationStore extends IApplicationStore {}

export { actions };

export type DispatchAsync<A extends Action = AnyAction> = <T extends A>(action: T) => Promise<void>;

export type Store<A extends Action = AnyAction> = {
    dispatch: DispatchAsync;
} & ReduxStore<ApplicationStore, A>;

export type GetState = Store["getState"];

let store: Store;

export let actionLog: ActionLog<any, AnyAction>;

// Return the Redux `composer` function with Dev Tools configured when appropriate
const getMiddlewareComposer = (env?: string) => {
    try {
        // Check if Redux Dev Tools are installed
        if (typeof (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ !== "function") {
            return compose;
        }

        // Make sure we aren't running tests
        if (process.env.NODE_ENV === "test") {
            return compose;
        }

        // Only allow on the prod env if we're running locally
        if (env === "prod" && process.env.NODE_ENV !== "development") {
            return compose;
        }

        // Try setting up redux dev tools
        return (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose;
    } catch (e) {
        return compose;
    }
};

const fillStore = (initialState: Partial<ApplicationStore>): Store => {
    actionLog = createActionLog({ limit: 15 });

    const middlewareComposer = getMiddlewareComposer(initialState.onlineShopper?.env);

    store = createStore(
        reducer,
        initialState,
        middlewareComposer(
            applyMiddleware(dataService, dynamicGarageReporter, garageManagement, thunk),
            actionLog.enhancer
        )
    );

    return store;
};

export default fillStore;

export function getStore() {
    return store;
}

export function getAppState() {
    return store && store.getState();
}
